// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import { cable } from "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
import "./controllers"

// When the tab regains focus (laptop wake, tab switch), force the
// Action Cable connection to reopen. The underlying WebSocket can go
// silently dead during sleep — readyState stays OPEN but no bytes flow
// — and Turbo Stream broadcasts (including primeta_send) reach a
// subscription that no longer exists server-side. Reopening triggers
// every turbo_stream_from on the page to resubscribe.
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") {
    cable.getConsumer().then((consumer) => consumer?.connection?.reopen?.())
  }
})
